export default __webpack_public_path__ + "static/media/error-woman.038cdc0b.svg";